import React, { Component } from 'react';
import {
  Container,
  Col,
  Row,
  Spinner,
  Badge
} from 'reactstrap';
import classnames from 'classnames';

import { Waypoint } from 'react-waypoint';
import DecadeSlides from "./DecadeSlides"   
import ChartViz from './ChartViz'
import DecadeViz from './DecadeViz'
import Quiz from './Quiz'
import { StickyContainer, Sticky } from 'react-sticky';

import Annotation from "./data/Annotation"
import DecadeSummary from "./data/DecadeSummary"
import Quotes from './data/Quotes'

import Photos1940 from './data/Photos1940'
import Photos1950 from "./data/Photos1950"
import Photos1960 from "./data/Photos1960"
import Photos1970 from "./data/Photos1970"
import Photos1980 from "./data/Photos1980"
import Photos1990 from "./data/Photos1990"
import Photos2000 from "./data/Photos2000"
import Photos2010 from "./data/Photos2010"

import Summaryall from "./data/Summaryall"
import Summary1940 from "./data/Summary1940"
import Summary1950 from "./data/Summary1950"
import Summary1960 from "./data/Summary1960"
import Summary1970 from "./data/Summary1970"
import Summary1980 from "./data/Summary1980"
import Summary1990 from "./data/Summary1990"
import Summary2000 from "./data/Summary2000"
import Summary2010 from "./data/Summary2010"

import General from "./data/General"
import Dataall from "./data/summary/Dataall"
import Data1940 from "./data/summary/Data1940"
import Data1950 from "./data/summary/Data1950"
import Data1960 from "./data/summary/Data1960"
import Data1970 from "./data/summary/Data1970"
import Data1980 from "./data/summary/Data1980"
import Data1990 from "./data/summary/Data1990"
import Data2000 from "./data/summary/Data2000"
import Data2010 from "./data/summary/Data2010"


class Decades extends Component {
  constructor(props) {
    super(props);
    this.state = {
      run:false,
      needfooter:false,
      activated:"",
      countall : 0,
      count40 : 0,
      count50 : 0,
      count60 : 0,
      count70 : 0,
      count80 : 0,
      count90 : 0,
      count00 : 0,
      count10 : 0,
      countout40 : 0,
      countout50 : 0,
      countout60 : 0,
      countout70 : 0,
      countout80 : 0,
      countout90 : 0,
      countout00 : 0,
      countout10 : 0
      }
      this.handleall = this.handleall.bind(this);
      this.handleout = this.handleout.bind(this);

      this.handle40 = this.handle40.bind(this);
      this.handle50 = this.handle50.bind(this);
      this.handle60 = this.handle60.bind(this);
      this.handle70 = this.handle70.bind(this);
      this.handle80 = this.handle80.bind(this);
      this.handle90 = this.handle90.bind(this);
      this.handle00 = this.handle00.bind(this);
      this.handle10 = this.handle10.bind(this);
      this.runTour = this.runTour.bind(this);


      this.handle40out = this.handle40out.bind(this);
      this.handle50out = this.handle50out.bind(this);
      this.handle60out = this.handle60out.bind(this);
      this.handle70out = this.handle70out.bind(this);
      this.handle80out = this.handle80out.bind(this);
      this.handle90out = this.handle90out.bind(this);
      this.handle00out = this.handle00out.bind(this);
      this.handle10out = this.handle10out.bind(this);
    }

    runTour(){
      this.setState({
        run: true,
      });
    }

    handleall() {
      this.setState(prevState => {
          return {needfooter: true}
      })}
    handleout() {
      this.setState(prevState => {
          return {needfooter: false}
      })}
    handle40() {
      this.setState(prevState => {
          return {count40: 1, activated:"1940"}
      })}
    handle50() {
      this.setState(prevState => {
          return {count50: 1, activated:"1950"}
      })}
    handle60() {
      this.setState(prevState => {
          return {count60: 1, activated:"1960"}
      })}
    handle70() {
      this.setState(prevState => {
          return {count70: 1, activated:"1970"}
      })}
    handle80() {
      this.setState(prevState => {
          return {count80: 1, activated:"1980"}
      })}
    handle90() {
      this.setState(prevState => {
          return {count90: 1, activated:"1990"}
      })}
    handle00() {
      this.setState(prevState => {
          return {count00: 1, activated:"2000"}
      })}
    handle10() {
      this.setState(prevState => {
          return {count10: 1, activated:"2010"}
      })}


      handle40out() {
        this.setState(prevState => {
            return {countout40: 1}
        })}
      handle50out() {
        this.setState(prevState => {
            return {countout50: 1}
        })}
      handle60out() {
        this.setState(prevState => {
            return {countout60: 1}
        })}
      handle70out() {
        this.setState(prevState => {
            return {countout70: 1}
        })}
      handle80out() {
        this.setState(prevState => {
            return {countout80: 1}
        })}
      handle90out() {
        this.setState(prevState => {
            return {countout90: 1}
        })}
      handle00out() {
        this.setState(prevState => {
            return {countout00: 1}
        })}
      handle10out() {
        this.setState(prevState => {
            return {countout10: 1}
        })}


  render() {
    let dataall = <ChartViz
                    cont={<div className="abso funfont"><h6 style={{top:"340px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"850px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"1100px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"1550px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"2000px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"2330px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"2465px"}}>{Annotation[0].annotation7AR}</h6></div>}
                    leftbox={<div className="abso"><h5 style={{top:"2030px"}}>{Annotation[1].annotation2AR}</h5></div>}
                    absbox={<div className="abso"><h5 style={{top:"1350px"}}>{Annotation[1].annotation3AR}</h5></div>}
                    rightbox={<div className="abso"><h5 style={{top:"100px"}}>{Annotation[1].annotation4AR}</h5><h5 style={{top:"1600px"}}>{Annotation[1].annotation5AR}</h5><h5 style={{top:"2260px"}}>{Annotation[1].annotation1AR}</h5></div>}
                    language={"Countryname"} continent="all" dataset={Dataall} annotate1940={true} annotatetut={true} height={2525}/>

    let data1940 = this.state.count40===1? <ChartViz
                  cont={<div className="abso funfont"><h6 style={{top:"70px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"125px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"175px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"260px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"450px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"610px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"680px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   leftbox={<div className="abso"><h5 style={{top:"300px"}}>{Annotation[2].annotation3AR}</h5></div>}
                   absbox={<div className="abso"><h5 style={{top:"50px"}}>{Annotation[2].annotation1AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"360px"}}>{Annotation[2].annotation2AR}</h5></div>}
                   language={"Countryname"} continent="1940" dataset={Data1940} annotate1940={true} annotatetut={true} height={737}/>: <div style={{height:"737px"}}> <Spinner color="warning" /></div>
    
    let data1950 = this.state.count50===1? <ChartViz
                  cont={<div className="abso funfont"><h6 style={{top:"90px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"200px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"293px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"440px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"690px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"880px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"980px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   absbox={<div className="abso"><h5 style={{top:"300px"}}>{Annotation[3].annotation1AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"440px"}}>{Annotation[3].annotation2AR}</h5></div>}
                   language={"Countryname"} continent="1950" dataset={Data1950} height={1040}/>: <div style={{height:"1040px"}}> <Spinner color="warning" /></div>
    
    let data1960 = this.state.count60===1? <ChartViz
    cont={<div className="abso funfont"><h6 style={{top:"300px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"600px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"707px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"880px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"1170px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"1400px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"1520px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   leftbox={<div className="abso"><h5 style={{top:"50px"}}>{Annotation[4].annotation1AR}</h5></div>}
                   absbox={<div className="abso"><h5 style={{top:"630px"}}>{Annotation[4].annotation3AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"950px"}}>{Annotation[4].annotation2AR}</h5></div>}
                   language={"Countryname"} continent="1960" dataset={Data1960} height={1580}/>: <div style={{height:"1580px"}}> <Spinner color="warning" /></div>
    
    let data1970 = this.state.count70===1? <ChartViz
    cont={<div className="abso funfont"><h6 style={{top:"300px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"710px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"870px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"1080px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"1420px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"1700px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"1840px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   leftbox={<div className="abso"><h5 style={{top:"900px"}}>{Annotation[5].annotation1AR}</h5></div>}
                   absbox={<div className="abso"><h5 style={{top:"475px"}}>{Annotation[5].annotation3AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"180px"}}>{Annotation[5].annotation2AR}</h5></div>}
                   language={"Countryname"} continent="1970" dataset={Data1970} height={1900}/>: <div style={{height:"1900px"}}> <Spinner color="warning" /></div>
    
    let data1980 = this.state.count80===1? <ChartViz
    cont={<div className="abso funfont"><h6 style={{top:"300px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"730px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"890px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"1100px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"1480px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"1790px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"1915px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   leftbox={<div className="abso"><h5 style={{top:"50px"}}>{Annotation[6].annotation1AR}</h5></div>}
                   absbox={<div className="abso"><h5 style={{top:"700px"}}>{Annotation[6].annotation2AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"1440px"}}>{Annotation[6].annotation3AR}</h5></div>}
                   language={"Countryname"} continent="1980" dataset={Data1980} height={1975}/>: <div style={{height:"1975px"}}> <Spinner color="warning" /></div>
    
    let data1990 = this.state.count90===1? <ChartViz
    cont={<div className="abso funfont"><h6 style={{top:"350px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"800px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"1040px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"1350px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"1800px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"2150px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"2265px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   leftbox={<div className="abso"><h5 style={{top:"80px"}}>{Annotation[7].annotation1AR}</h5></div>}
                   absbox={<div className="abso"><h5 style={{top:"1200px"}}>{Annotation[7].annotation3AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"2030px"}}>{Annotation[7].annotation2AR}</h5></div>}
                   language={"Countryname"} continent="1990" dataset={Data1990} height={2325}/>: <div style={{height:"2325px"}}> <Spinner color="warning" /></div>
    
    let data2000 = this.state.count00===1? <ChartViz
    cont={<div className="abso funfont"><h6 style={{top:"350px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"800px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"1060px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"1450px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"1950px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"2250px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"2375px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   leftbox={<div className="abso"><h5 style={{top:"50px"}}>{Annotation[8].annotation1AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"200px"}}>{Annotation[8].annotation3AR}</h5><h5 style={{top:"1060px"}}>{Annotation[8].annotation2AR}</h5></div>}
                   language={"Countryname"} continent="2000" dataset={Data2000} height={2435}/>: <div style={{height:"2435px"}}> <Spinner color="warning" /></div>
    
    let data2010 = this.state.count10===1? <ChartViz
    cont={<div className="abso funfont"><h6 style={{top:"360px"}}>{Annotation[0].annotation1AR}</h6><h6 style={{top:"820px"}}>{Annotation[0].annotation2AR}</h6><h6 style={{top:"1080px"}}>{Annotation[0].annotation3AR}</h6><h6 style={{top:"1450px"}}>{Annotation[0].annotation4AR}</h6><h6 style={{top:"1950px"}}>{Annotation[0].annotation5AR}</h6><h6 style={{top:"2250px"}}>{Annotation[0].annotation6AR}</h6><h6 style={{top:"2375px"}}>{Annotation[0].annotation7AR}</h6></div>}
                   leftbox={<div className="abso"><h5 style={{top:"50px"}}>{Annotation[9].annotation1AR}</h5></div>}
                   absbox={<div className="abso"><h5 style={{top:"530px"}}>{Annotation[9].annotation2AR}</h5></div>}
                   rightbox={<div className="abso"><h5 style={{top:"2180px"}}>{Annotation[9].annotation3AR}</h5></div>}
                   language={"Countryname"} continent="2010" dataset={Data2010} height={2435}/>: <div style={{height:"2435px"}}> <Spinner color="warning" /></div>
    return (

    <div>
<Container>
          <Row className="justify-content-center">
              <Col lg="10" md="10" xs="12" className="text-right">
                <h2 className="display-2 text-center">{General[2].chapterAR}</h2>
                <p>{General[2].subAR}</p>
                <br/>
                <em className="gray pad--20">{General[6].chapterAR}</em>
                <br/>
                <br/>
              </Col>
          </Row>
</Container>



<Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                <Waypoint onEnter={()=> {this.handleall()}}/>
                  <div>
                  <DecadeViz language={"Countryname"} dataset={Summaryall} height={40}/>
                  {dataall}   
                  {/* <ChartViz language={"Countryname"} dataset={Dataall} annotate1940={true} annotatetut={true} height={900}/> */}
                  </div>
                </Col>
            </Row>
        </Container>
       

      <Container>
      <hr/>
          <Row className="justify-content-center">
              <Col lg="10" md="10" xs="12" className="text-right">
                <h2 className="display-2 text-center">{General[3].chapterAR}</h2>
                <p className="text-center nomargin">{General[3].subAR}</p>
              </Col>
            </Row>
      </Container>


                <StickyContainer>
                <Container>
              <Row className="justify-content-center">
              <Col lg="10" md="10" xs="12" className="text-right">
                <Sticky>{({ style }) => 
                <p style={style} className="bean text-center">
                <a href="#y1940s"><Badge className={classnames({ orangebox: this.state.activated === "1940"})} color="secondary">1940</Badge></a>
                <a href="#y1950s"><Badge className={classnames({ orangebox: this.state.activated === "1950"})} color="secondary">1950</Badge></a>
                <a href="#y1960s"><Badge className={classnames({ orangebox: this.state.activated === "1960"})} color="secondary">1960</Badge></a>
                <a href="#y1970s"><Badge className={classnames({ orangebox: this.state.activated === "1970"})} color="secondary">1970</Badge></a>
                <a href="#y1980s"><Badge className={classnames({ orangebox: this.state.activated === "1980"})} color="secondary">1980</Badge></a>
                <a href="#y1990s"><Badge className={classnames({ orangebox: this.state.activated === "1990"})} color="secondary">1990</Badge></a>
                <a href="#y2000s"><Badge className={classnames({ orangebox: this.state.activated === "2000"})} color="secondary">2000</Badge></a>
                <a href="#y2010s"><Badge className={classnames({ orangebox: this.state.activated === "2010"})} color="secondary">2010</Badge></a>
                </p>}
                </Sticky>
              </Col>
          </Row>
      </Container>
      <div id="y1940s"></div>

      <DecadeSlides start={1940} end={1949} caption={General[8].chapterAR} dataset={Photos1940}/>
      <Waypoint onEnter={()=> {this.handle40()}} onLeave={()=> {this.handle40out()}}>
        <div>
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[0].SummaryAR}</p>
                    <Quiz quote={Quotes[0].quoteAR} persona={Quotes[0].person1AR} personb={Quotes[0].person2AR} personc={Quotes[0].person3AR} notes={Quotes[0].NotesAR}/>
                    <br/>
                    <br/>
                </Col>
            </Row>
        </Container>

        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                  <DecadeViz language={"Countryname"} dataset={Summary1940} height={40}/>
                  {data1940}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>





        <div className="afterwards" id="y1950s"></div>
        <DecadeSlides start={1950} end={1959} caption={General[8].chapterAR} dataset={Photos1950}/>
        <Waypoint onEnter={()=> {this.handle50()}} onLeave={()=> {this.handle50out()}}>
        <div>
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[1].SummaryAR}</p>
                    <Quiz quote={Quotes[1].quoteAR} persona={Quotes[1].person1AR} personb={Quotes[1].person2AR} personc={Quotes[1].person3AR} notes={Quotes[1].NotesAR}/>
                    <br/>
                    <br/>
                </Col>
            </Row>
        </Container>
        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                <DecadeViz language={"Countryname"} dataset={Summary1950} height={40}/>
                
                {data1950}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>









        <div className="afterwards" id="y1960s"></div>
        <DecadeSlides start={1960} end={1969} caption={General[8].chapterAR} dataset={Photos1960}/>
        <Waypoint onEnter={()=> {this.handle60()}} onLeave={()=> {this.handle60out()}}>
        <div>
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[2].SummaryAR}</p>
                    <Quiz quote={Quotes[2].quoteAR} persona={Quotes[2].person1AR} personb={Quotes[2].person2AR} personc={Quotes[2].person3AR} notes={Quotes[2].NotesAR}/>
                    <br/>
                    <br/>
                </Col>
            </Row>
        </Container>
        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                    <DecadeViz language={"Countryname"} dataset={Summary1960} height={40}/>
                    
                    {data1960}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>












        <div className="afterwards" id="y1970s"></div>
        <DecadeSlides start={1970} end={1979} caption={General[8].chapterAR} dataset={Photos1970}/>
        <Waypoint onEnter={()=> {this.handle70()}} onLeave={()=> {this.handle70out()}}>
        <div>
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[3].SummaryAR}</p>
                    <Quiz quote={Quotes[3].quoteAR} persona={Quotes[3].person1AR} personb={Quotes[3].person2AR} personc={Quotes[3].person3AR} notes={Quotes[3].NotesAR}/>
                    <br/>
                    <br/>
                </Col>
            </Row>
        </Container>
        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                    <DecadeViz language={"Countryname"} dataset={Summary1970} height={40}/>
                    
                    {data1970}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>














        <div className="afterwards" id="y1980s"></div>      
        <DecadeSlides start={1980} end={1989} caption={General[8].chapterAR} dataset={Photos1980}/>
        <Waypoint onEnter={()=> {this.handle80()}} onLeave={()=> {this.handle80out()}}>
        <div>  
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[4].SummaryAR}</p>
                    <Quiz quote={Quotes[4].quoteAR} persona={Quotes[4].person1AR} personb={Quotes[4].person2AR} personc={Quotes[4].person3AR} notes={Quotes[4].NotesAR}/>
                  <br/>
                  <br/>
                </Col>
            </Row>
        </Container>
        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                    <DecadeViz language={"Countryname"} dataset={Summary1980} height={40}/>
                    
                    {data1980}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>














        <div className="afterwards" id="y1990s"></div>
        <DecadeSlides start={1990} end={1999} caption={General[8].chapterAR} dataset={Photos1990}/>
        <Waypoint onEnter={()=> {this.handle90()}} onLeave={()=> {this.handle90out()}}>
        <div>
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[5].SummaryAR}</p>
                    <Quiz quote={Quotes[5].quoteAR} persona={Quotes[5].person1AR} personb={Quotes[5].person2AR} personc={Quotes[5].person3AR} notes={Quotes[5].NotesAR}/>
                    <br/>
                    <br/>
                </Col>
            </Row>
        </Container>
        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                    <DecadeViz language={"Countryname"} dataset={Summary1990} height={40}/>
                    
                    {data1990}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>










        <div className="afterwards" id="y2000s"></div>
        <DecadeSlides start={2000} end={2009} caption={General[8].chapterAR} dataset={Photos2000}/>
        <Waypoint onEnter={()=> {this.handle00()}} onLeave={()=> {this.handle00out()}}>
        <div>
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[6].SummaryAR}</p>
                    <Quiz quote={Quotes[6].quoteAR} persona={Quotes[6].person1AR} personb={Quotes[6].person2AR} personc={Quotes[6].person3AR} notes={Quotes[6].NotesAR}/>
                    <br/>
                    <br/>
                </Col>
                
            </Row>
        </Container>
        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                    <DecadeViz language={"Countryname"} dataset={Summary2000} height={40}/>
                    
                    {data2000}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>








        <div className="afterwards" id="y2010s"></div>
        <DecadeSlides start={2010} end={2019} caption={General[8].chapterAR} dataset={Photos2010}/>
        <Waypoint onEnter={()=> {this.handle10()}} onLeave={()=> {this.handle10out()}}>
        <div>
        <Container>
            <Row className="justify-content-center align-items-center">
                <Col lg="10" md="10" xs="12" className="text-right">
                    <br/>
                    <p>{DecadeSummary[7].SummaryAR}</p>
                    <Quiz quote={Quotes[7].quoteAR} persona={Quotes[7].person1AR} personb={Quotes[7].person2AR} personc={Quotes[7].person3AR} notes={Quotes[7].NotesAR}/>
                    <br/>
                    <br/>
                  
                </Col>
            </Row>
        </Container>
        <Container fluid className="no-gutters no-padding">
            <Row className="no-gutters no-padding justify-content-center">
                <Col xs="12" className="text-center">
                    <DecadeViz language={"Countryname"} dataset={Summary2010} height={40}/>
                    
                    {data2010}
                </Col>
            </Row>
        </Container>
        </div>
        </Waypoint>
        <div className="afterwards"></div>
        <Waypoint onLeave={()=> {this.handleout()}}/>
</StickyContainer>
      </div>
    )
}
}
export default Decades